import { render, staticRenderFns } from "./Regs.vue?vue&type=template&id=5050cc18&scoped=true&"
import script from "./Regs.vue?vue&type=script&lang=js&"
export * from "./Regs.vue?vue&type=script&lang=js&"
import style0 from "./Regs.vue?vue&type=style&index=0&id=5050cc18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050cc18",
  null
  
)

export default component.exports